import { render } from "./HomeProviders.vue?vue&type=template&id=5ba1463c&scoped=true&ts=true"
import script from "./HomeProviders.vue?vue&type=script&lang=ts"
export * from "./HomeProviders.vue?vue&type=script&lang=ts"

import "./HomeProviders.vue?vue&type=style&index=0&id=5ba1463c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba1463c"]])

export default __exports__